import {
  ORDER_ID_CHANGED,
  DATA_CHANGED,
  ORDER_DATA_CHANGED,
  ORDER_DATA_PROBLEM_DESCRIPTION_CHANGED,
  ORDER_DATA_OFFICIAL_NAME_CHANGED,
  ORDER_DATA_REQUIRED_CREATE_NEW_ORDER_VERSION_CHANGED,
  ORDER_DATA_VERSION_METADATA_MESSAGE_CHANGED,
  INSTRUCTION_VERSIONS_CHANGED,
  INSTRUCTION_VERSION_DATA_CHANGED,
  INSTRUCTION_VERSION_PARAGRAPH_ADD,
  INSTRUCTION_WAS_EDITED, INSTRUCTION_VERSION_PARAGRAPH_DELETE,
  INSTRUCTION_LOADING,
  INSTRUCTION_PARAGRAPH_UP, INSTRUCTION_PARAGRAPH_DOWN, INSTRUCTION_SAVE_ERROR
} from '../actions/instuctionActions';

export const initialState = {
  orderId: null,
  data: null,
  orderData: {
    problemDescription: null,
    officialName: null
  },
  requiredCreateNewOrderVersion: false,
  versionMetadataMessage: "",
  instructionWasEdited: false,
  versions: [],
  instructionLoading: false,
  saveError: null
};

function move (array, from, to) {
  [array[from], array[to]] = [array[to], array[from]]
  return array;
}

export default function instructionsReducer (state = initialState, action) {
  switch (action.type) {
    case ORDER_ID_CHANGED:
      return {
        ...state,
        orderId: action.payload
      };
    case DATA_CHANGED:
      return {
        ...state,
        data: action.payload
      };
    case ORDER_DATA_CHANGED:
      return {
        ...state,
        orderData: action.payload
      };
    case ORDER_DATA_PROBLEM_DESCRIPTION_CHANGED:
      return {
        ...state,
        requiredCreateNewOrderVersion: true,
        orderData: {
          ...state.orderData,
          problemDescription: action.payload
        }
      };
    case ORDER_DATA_OFFICIAL_NAME_CHANGED:
      return {
        ...state,
        requiredCreateNewOrderVersion: true,
        orderData: {
          ...state.orderData,
          officialName: action.payload
        }
      };
    case ORDER_DATA_REQUIRED_CREATE_NEW_ORDER_VERSION_CHANGED:
      return {
        ...state,
        requiredCreateNewOrderVersion: action.payload
      }
    case ORDER_DATA_VERSION_METADATA_MESSAGE_CHANGED:
      return {
        ...state,
        versionMetadataMessage: action.payload
      }
    case INSTRUCTION_VERSIONS_CHANGED:
      return {
        ...state,
        instructionWasEdited: false,
        versions: action.payload
      };
    case INSTRUCTION_VERSION_DATA_CHANGED:
      return {
        ...state,
        instructionWasEdited: true,
        versions: state.versions.map((version, index) => {
          if (index !== action.versionIndex) return version;
          return {
            ...version,
            data: version.data.map((d, i) => {
              if(i !== action.dataIndex) return d;
              return action.payload;
            })
          }
        })
      };
    case INSTRUCTION_VERSION_PARAGRAPH_ADD:
      return {
        ...state,
        versions: state.versions.map((version, index)=> {
          if(index !== action.versionIndex) return version;
          version.data.push(action.payload);
          return version;
        })
      }
    case INSTRUCTION_VERSION_PARAGRAPH_DELETE:
      return {
        ...state,
        instructionWasEdited: true,
        versions: state.versions.map((version, index)=> {
          if(index !== action.versionIndex) return version;
          version.data.splice(action.dataIndex, 1);
          return version;
        })
      }
    case INSTRUCTION_WAS_EDITED:
      return {
        ...state,
        instructionWasEdited: action.payload
      }
    case INSTRUCTION_LOADING:
      return {
        ...state,
        instructionLoading: action.payload
      }
    case INSTRUCTION_PARAGRAPH_UP:
      return {
        ...state,
        versions: state.versions.map((version, index) => {
          if(index !== state.versions.length - 1) return version;
          return {...version, data: move(version.data, action.payload - 1, action.payload)};
        })
      }
    case INSTRUCTION_PARAGRAPH_DOWN:
      return {
        ...state,
        versions: state.versions.map((version, index) => {
          if(index !== state.versions.length - 1) return version;
          return {...version, data: move(version.data, action.payload + 1, action.payload)};
        })
      }
    case INSTRUCTION_SAVE_ERROR:
      return {
        ...state,
        saveError: action.payload
      }
    default:
      return state;
  }
}

